import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { counter_GROUP_POSTS, SHOW_ALL_GROUPS } from 'mk/autogenerated/translations/UserGroupsList.f4768ff11f3de2c2c1d12656072890f7'
import { photoUrl } from 'mk/photo/photoUrl';
import { groupsGroupUrl } from 'mk2/apps/groups/urls';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Img } from 'mk2/components/Img';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import { LoadingState } from 'mk2/reducers/loadingState';
import { GroupEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './UserGroupsList.mscss';

interface OwnProps {
    id?: string;
    countAll: number;
    hasMore: boolean;
    header: string;
    loadingState: LoadingState;
    groups: GroupEntity[];

    onExpand();
}

type Props = OwnProps;

export default class UserGroupsList extends React.Component<Props> {
    private instanceRef = React.createRef<HTMLDivElement>();

    public render() {
        const {
            countAll, groups, hasMore, header, onExpand, id,
        } = this.props;

        return (
            <div className={styles.UserGroupsList} id={id}>
                <h2>{header} <span>({countAll})</span></h2>
                <div className={styles.UserGroupsList__groups}>
                    {groups.map((group, index) => {
                        return (
                            <div className={styles.UserGroupsList__groups__group} key={index}>
                                <Link
                                    to={url(groupsGroupUrl, { groupId: group.id })}
                                    key={index}
                                >
                                    {!group.coverPhoto ? (
                                        <div className={styles.UserGroupsList__groups__group__photo}>
                                            <FontAwesomeIcon icon={faUsers} />
                                        </div>
                                    ) : (
                                        <Img
                                            className={styles.UserGroupsList__groups__group__photo}
                                            src={photoUrl(group.coverPhoto, 'c50x50')}
                                            width={50}
                                            height={50}
                                        />
                                    )}
                                </Link>
                                <div className={styles.UserGroupsList__groups__group__detail}>
                                    <Link to={url(groupsGroupUrl, { groupId: group.id })}>{group.name}</Link>
                                    <div>{interpolate(counter_GROUP_POSTS, {counter: group.postsCount, count: group.postsCount})}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {hasMore && (
                    <div className={styles.UserGroupsList__more}>
                        <Btn
                            label={SHOW_ALL_GROUPS}
                            type={BtnType.Link}
                            sidePadding={0}
                            onClick={onExpand}
                        />
                    </div>
                )}
            </div>
        );
    }
}
